export interface Limit {
  total: number;
  count: number;
  size: number;
}

export const createLimit = (
  total: number = 0,
  count: number = 0,
  size: number = 0
): Limit => ({
  total: total,
  count: count,
  size: size,
});
